define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.readCookie = void 0;
    // eslint-disable-next-line import/prefer-default-export
    const readCookie = (k) => {
        const b = document.cookie.match(`(^|;)\\s*${k}\\s*=\\s*([^;]+)`);
        return b ? b.pop() : '';
    };
    exports.readCookie = readCookie;
});
//# sourceMappingURL=cookies.js.map